import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
/* eslint-disable max-len */
import { createBackoff, getBackoff, removeBackoff } from './utils/backoff';
import { addEvent, getApi2host, safeJSONParse, transformSymbolsData, transformResponse, getDefaultLang, isClient, mergeArrayObjects } from './utils/tools';
import processSymbolData from './handleSymbols';
import { SYMBOL_LIST_API, SPOT_SYMBOLS_DATA, SPOT_SYMBOLS_DATA_COMMON, MIN_RETRY_INTERVAL, MAX_RETRY_INTERVAL, MAX_RETRY_TIMES } from './constants';
import http from './service';
import { sharedData } from './sharedData';
import { TraceCode } from './traceCode';
import SYMBOLS from './symbols';

// 降级请求v2接口
var fallbackV2 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opt) {
    var res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 降级请求v2接口-上报
          addEvent('symbol_list_error', {
            c: TraceCode.FALLBACK_TO_V2,
            m: 'fallback to v2'
          });

          // 降级到v2时，说明本地缓存可能缺失币对，需要删除已缓存的CDN币对列表，避免下次请求时，使用缺失的缓存数据，进而导致币对列表不全，又会进入到降级请求v2接口的逻辑
          localStorage.removeItem(SPOT_SYMBOLS_DATA_COMMON);

          // v2接口返回的数据处理结果
          res = {};
          _context.prev = 3;
          _context.next = 6;
          return http.get("".concat(getApi2host()).concat(SYMBOL_LIST_API.V2), opt);
        case 6:
          res = _context.sent;
          res = transformResponse(res);
          _context.next = 14;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          // v2接口请求异常
          addEvent('symbol_list_error', {
            c: TraceCode.FALLBACK_TO_V2_REQUEST_ERROR,
            m: _context.t0.message || 'fallback to v2 request error'
          });
          res = transformResponse(_context.t0);
        case 14:
          return _context.abrupt("return", Promise.resolve(res));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return function fallbackV2(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 获取币对列表主方法
 * @param {String} lang - 接口当前传入的语言，默认先获取本地缓存中的语言，如果没有，就使用默认语言 'en'
 * @param {Object} options - 配置项
 * @param {Boolean} options.useCache - 是否使用缓存，默认为true
 * @returns {Promise} - 返回币对列表Promise
 */
var getSymbols = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var lang,
      _ref3,
      _ref3$useCache,
      useCache,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          lang = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : getDefaultLang();
          _ref3 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, _ref3$useCache = _ref3.useCache, useCache = _ref3$useCache === void 0 ? true : _ref3$useCache;
          if (isClient) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", Promise.resolve(processSymbolData([])));
        case 4:
          if (!sharedData.symbolsPromise) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return", sharedData.symbolsPromise);
        case 6:
          // 创建一个新的Promise
          sharedData.symbolsPromise = new Promise(function (resolve) {
            // 由于Promise中不能直接用async/await，故用函数包裹
            var fetchSymbols = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(isStrongError) {
                var _sharedData$cacheSymb, _sharedData$cacheSymb2, _sharedData$cacheSymb3, _sharedData$cacheSymb4, _sharedData$cacheSymb5, _sharedData$cacheSymb6, _sharedData$cacheSymb7, lastModifiedTime, version, res, opt, optCdn, isMergeError, setIsMergeError, _result, allRes, V3Res, _sharedData$cacheSymb8, i, item, _res, success, result;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      // 删除旧的币对列表缓存，统一用新的缓存字段'SPOT_SYMBOLS_DATA'
                      localStorage.removeItem('spotSymbolData');

                      // 从缓存获取完整币对列表+版本号
                      sharedData.cacheSymbolsData = safeJSONParse(localStorage.getItem(SPOT_SYMBOLS_DATA));

                      // 从缓存获取CDN币对列表+lastModifiedTime
                      sharedData.cacheSymbolsDataCdn = safeJSONParse(localStorage.getItem(SPOT_SYMBOLS_DATA_COMMON));

                      // 如果接口请求失败，不重试，或者已重试请求达到MAX_RETRY_TIMES次，又或者进入到catch，就走本地缓存逻辑
                      if (!isStrongError) {
                        _context2.next = 9;
                        break;
                      }
                      // 清除backoff重试的指针
                      removeBackoff(sharedData.BACKOFF_ID);

                      // 如果缓存存在，直接使用缓存数据
                      if ((_sharedData$cacheSymb = sharedData.cacheSymbolsData) === null || _sharedData$cacheSymb === void 0 ? void 0 : _sharedData$cacheSymb.quoteTokenResult) {
                        // 使用缓存交易对，异常上报
                        addEvent('symbol_list_error', {
                          c: TraceCode.USE_CACHE_CODE_DATA,
                          m: 'use cache data'
                        });

                        // 返回本地缓存数据
                        resolve(processSymbolData(sharedData.cacheSymbolsData.quoteTokenResult));
                      } else {
                        // 使用大兜底交易对，异常上报
                        addEvent('symbol_list_error', {
                          c: TraceCode.USE_HARD_CODE_DATA,
                          m: 'use hard code data'
                        });

                        // 本地缓存不存在，走大兜底的交易对列表
                        resolve(processSymbolData(SYMBOLS.quoteTokenResult));
                      }
                      _context2.next = 63;
                      break;
                    case 9:
                      // 走接口请求逻辑
                      // 本地缓存的CDN币对列表时间戳，用作入参查询是否有增量更新的CDN币对列表
                      lastModifiedTime = ''; // 本地缓存的币对列表版本号，用作入参查询是否有新版本的币对列表，针对v2和v3（后续可能有）接口
                      version = ''; // 已做统一处理的接口返回数据
                      res = {}; // 如果本地缓存的币对列表存在 && 版本号存在，才获取对应的版本号
                      if (((_sharedData$cacheSymb2 = sharedData.cacheSymbolsData) === null || _sharedData$cacheSymb2 === void 0 ? void 0 : (_sharedData$cacheSymb3 = _sharedData$cacheSymb2.quoteTokenResult) === null || _sharedData$cacheSymb3 === void 0 ? void 0 : _sharedData$cacheSymb3.length) && ((_sharedData$cacheSymb4 = sharedData.cacheSymbolsData) === null || _sharedData$cacheSymb4 === void 0 ? void 0 : _sharedData$cacheSymb4.version)) {
                        version = sharedData.cacheSymbolsData.version;
                      }

                      // 如果缓存的CDN币对列表存在 && 时间戳存在，才获取对应的时间戳
                      if (((_sharedData$cacheSymb5 = sharedData.cacheSymbolsDataCdn) === null || _sharedData$cacheSymb5 === void 0 ? void 0 : (_sharedData$cacheSymb6 = _sharedData$cacheSymb5.quoteTokenSymbols) === null || _sharedData$cacheSymb6 === void 0 ? void 0 : _sharedData$cacheSymb6.length) && ((_sharedData$cacheSymb7 = sharedData.cacheSymbolsDataCdn) === null || _sharedData$cacheSymb7 === void 0 ? void 0 : _sharedData$cacheSymb7.lastModifiedTime)) {
                        lastModifiedTime = sharedData.cacheSymbolsDataCdn.lastModifiedTime;
                      }

                      // 通用接口请求参数
                      opt = {
                        headers: {
                          lang: lang,
                          'Accept-Language': lang
                        },
                        useCache: useCache,
                        rewriteCacheKey: function rewriteCacheKey(url) {
                          return "".concat(url, "&").concat(lang);
                        }
                      }; // CDN接口请求参数
                      optCdn = _objectSpread({}, opt); // 如果有lastModifiedTime，就添加到CDN接口请求参数 params 中
                      if (lastModifiedTime) {
                        optCdn = _objectSpread(_objectSpread({}, optCdn), {}, {
                          params: {
                            last_modified_at: lastModifiedTime
                          }
                        });
                      }

                      // 如果有版本号，就添加到v2/v3接口请求参数 params 中
                      if (version) {
                        opt = _objectSpread(_objectSpread({}, opt), {}, {
                          params: {
                            version: version
                          }
                        });
                      }

                      // 请求接口获取完整币对列表
                      _context2.prev = 18;
                      // 是否合并异常（处理 CDN接口返回的币对缺少，和v3接口币对不对应的情况），用作兜底逻辑判断
                      isMergeError = false; // 设置合并异常标识，基于eslint规则，故用函数包裹
                      setIsMergeError = function setIsMergeError() {
                        isMergeError = true;
                      }; // 请求 CDN缓存的币对列表 和 v3接口的币对列表
                      _context2.next = 23;
                      return Promise.all([http.get("".concat(getApi2host()).concat(SYMBOL_LIST_API.ALL), optCdn), http.get("".concat(getApi2host()).concat(SYMBOL_LIST_API.V3), opt)]);
                    case 23:
                      _result = _context2.sent;
                      // 格式化 CDN缓存的币对列表（非用户相关的币对和字段）
                      allRes = transformResponse(_result[0]); // 格式化 和用户相关的币对列表和字段
                      V3Res = transformResponse(_result[1]); // 如果CDN缓存的币对列表请求成功，就缓存到本地，用作下次增量请求
                      if (allRes.success) {
                        // 如果本地缓存的CDN币对列表存在，就合并两个接口的数据
                        if ((_sharedData$cacheSymb8 = sharedData.cacheSymbolsDataCdn) === null || _sharedData$cacheSymb8 === void 0 ? void 0 : _sharedData$cacheSymb8.quoteTokenSymbols) {
                          allRes.result.quoteTokenSymbols = [].concat(_toConsumableArray(sharedData.cacheSymbolsDataCdn.quoteTokenSymbols), _toConsumableArray(allRes.result.quoteTokenSymbols));
                        }
                        localStorage.setItem(SPOT_SYMBOLS_DATA_COMMON, JSON.stringify(allRes.result));
                      }

                      // 如果 CDN缓存的币对列表 和 用户相关的币对列表 都请求成功，才合并两个接口的数据，组成完整的币对列表
                      if (!(allRes.success && V3Res.success)) {
                        _context2.next = 38;
                        break;
                      }
                      i = 0;
                    case 29:
                      if (!(i < V3Res.result.quoteTokenResult.length)) {
                        _context2.next = 37;
                        break;
                      }
                      item = V3Res.result.quoteTokenResult[i]; // 合并quoteTokenSymbols字段
                      mergeArrayObjects(item.quoteTokenSymbols, allRes.result.quoteTokenSymbols, function () {
                        // 合并异常时，设置 合并异常标识
                        setIsMergeError();
                      });

                      // 如果合并异常（CDN接口数据中的币对，不存在于V3接口数据中；例如：新币上线，CDN接口有缓存时效，没有返回该新币），就跳出循环
                      if (!isMergeError) {
                        _context2.next = 34;
                        break;
                      }
                      return _context2.abrupt("break", 37);
                    case 34:
                      i += 1;
                      _context2.next = 29;
                      break;
                    case 37:
                      if (!isMergeError) {
                        res = V3Res;
                      }
                    case 38:
                      if (!(isMergeError || !allRes.success || !V3Res.success)) {
                        _context2.next = 43;
                        break;
                      }
                      if (isMergeError) {
                        // 合并交易对异常上报
                        addEvent('symbol_list_error', {
                          c: TraceCode.MERGE_SYMBOLS_ERROR,
                          m: 'merge symbols error'
                        });
                      } else if (!allRes.success) {
                        // CDN接口请求异常（http状态码200，但是接口返回的code不是0）
                        addEvent('symbol_list_error', {
                          c: TraceCode.CDN_REQUEST_CODE_ERROR,
                          m: 'cdn request error'
                        });
                      } else if (!V3Res.success) {
                        // v3接口请求异常（http状态码200，但是接口返回的code不是0）
                        addEvent('symbol_list_error', {
                          c: TraceCode.V3_REQUEST_CODE_ERROR,
                          m: 'v3 request error'
                        });
                      }

                      // 降级请求v2接口
                      _context2.next = 42;
                      return fallbackV2(opt);
                    case 42:
                      res = _context2.sent;
                    case 43:
                      _context2.next = 51;
                      break;
                    case 45:
                      _context2.prev = 45;
                      _context2.t0 = _context2["catch"](18);
                      // symbol_list_all/symbol_list_v3 接口请求异常
                      addEvent('symbol_list_error', {
                        c: TraceCode.API_SPLIT_REQUEST_ERROR,
                        m: _context2.t0.message || 'all/v3 request error'
                      });

                      // 降级请求v2接口
                      _context2.next = 50;
                      return fallbackV2(opt);
                    case 50:
                      res = _context2.sent;
                    case 51:
                      _res = res, success = _res.success, result = _res.result;
                      if (!(success && result)) {
                        _context2.next = 59;
                        break;
                      }
                      // 此处的quoteTokenResult可能是接口返回的数据（v2版本的version说明：如果version没有变更，quoteTokenResult的值为null），也可能是缓存的数据，故有以下判断：如果quoteTokenResult为null，说明version没有变更，此时使用本地缓存的quoteTokenResult
                      if (!result.quoteTokenResult) {
                        result.quoteTokenResult = sharedData.cacheSymbolsData.quoteTokenResult;
                      } else {
                        // 接口返回的数据，由于symbol_list v1 -> v2/v3/cdn接口 做了字段压缩，需做下清洗映射处理
                        result.quoteTokenResult = transformSymbolsData(result.quoteTokenResult);
                      }

                      // 清除backoff重试的指针
                      removeBackoff(sharedData.BACKOFF_ID);

                      // 把币对列表+版本号缓存到本地登录后，由于币对和用户相关，缓存逻辑在接口失败，极端场景下，用户看到的币对信息可能不是最新状态，会引发客诉，此场景已和产品@ryan.ren、@lip.du（2024.5.20）同步，产品可接受
                      localStorage.setItem(SPOT_SYMBOLS_DATA, JSON.stringify(result));

                      // 返回请求结果
                      resolve(processSymbolData(result.quoteTokenResult));
                      _context2.next = 63;
                      break;
                    case 59:
                      if (!(MAX_RETRY_TIMES === 0)) {
                        _context2.next = 62;
                        break;
                      }
                      fetchSymbols(true);
                      return _context2.abrupt("return");
                    case 62:
                      // 重试请求
                      if (!getBackoff(sharedData.BACKOFF_ID) && !sharedData.retryInProgress) {
                        sharedData.retryInProgress = true;
                        // 如果backoff不存在，就创建一个新的backoff实例
                        createBackoff(sharedData.BACKOFF_ID, {
                          min: MIN_RETRY_INTERVAL,
                          max: MAX_RETRY_INTERVAL,
                          maxCount: MAX_RETRY_TIMES,
                          callback: function callback() {
                            // 重试超过MAX_RETRY_TIMES次后，走本地缓存逻辑
                            if (sharedData.getSymbolsRetryTimes >= MAX_RETRY_TIMES) {
                              sharedData.retryInProgress = false;
                              // 异常上报
                              addEvent('symbol_list_error', {
                                c: TraceCode.RETRY_REQUEST_MAX_ERROR,
                                m: "retry request max times ".concat(MAX_RETRY_TIMES)
                              });
                              return fetchSymbols(true);
                            }

                            // 异常上报
                            addEvent('symbol_list_error', {
                              c: TraceCode.RETRY_REQUEST_ERROR,
                              m: "retry request error, retry times ".concat(sharedData.getSymbolsRetryTimes)
                            });

                            // 重试次数+1
                            sharedData.getSymbolsRetryTimes += 1;

                            // 重试请求
                            return fetchSymbols();
                          }
                        });
                      }
                    case 63:
                      _context2.next = 70;
                      break;
                    case 65:
                      _context2.prev = 65;
                      _context2.t1 = _context2["catch"](0);
                      // 异常上报
                      addEvent('symbol_list_error', {
                        c: TraceCode.CODE_EXECUTION_ERROR,
                        m: _context2.t1.message || 'code execution error'
                      });

                      // 重置重试中的状态
                      sharedData.retryInProgress = false;

                      // 走到这里，说明代码抛出异常，走本地缓存逻辑
                      fetchSymbols(true);
                    case 70:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 65], [18, 45]]);
              }));
              return function fetchSymbols(_x2) {
                return _ref4.apply(this, arguments);
              };
            }();

            // 执行获取币对列表函数
            fetchSymbols();
          }).finally(function () {
            // 重置重试中的状态
            sharedData.retryInProgress = false;

            // 清空Promise，以便下次请求
            sharedData.symbolsPromise = null;
          });

          // 返回Promise
          return _context3.abrupt("return", sharedData.symbolsPromise);
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getSymbols() {
    return _ref2.apply(this, arguments);
  };
}();

// 导出 v2接口映射关系
export { API_KEY_MAP } from './constants';

// 导出 symbol_list获取方法
export default getSymbols;